import { render, staticRenderFns } from "./CredenciamentoFornecedorItens.vue?vue&type=template&id=65446bbc&scoped=true"
import script from "./CredenciamentoFornecedorItens.vue?vue&type=script&lang=js"
export * from "./CredenciamentoFornecedorItens.vue?vue&type=script&lang=js"
import style0 from "./CredenciamentoFornecedorItens.vue?vue&type=style&index=0&id=65446bbc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65446bbc",
  null
  
)

export default component.exports